module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "file-manager"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('form', {
    staticClass: "form",
    attrs: {
      "id": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.addFile($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "id": "fileBrowser"
    },
    on: {
      "change": _vm.onFileChange
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "value": "+ Add"
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.files), function(file) {
    return _c('tr', [_c('td', [_c('a', {
      attrs: {
        "target": "_blank",
        "href": file.url
      }
    }, [_vm._v(_vm._s(file.name))])]), _vm._v(" "), _c('td', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:top",
        value: ('Remove'),
        expression: "'Remove'",
        arg: "top"
      }],
      staticClass: "action",
      on: {
        "click": function($event) {
          _vm.removeFile(file)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash fa-fw",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('td', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:top",
        value: ('Copy URL'),
        expression: "'Copy URL'",
        arg: "top"
      }],
      staticClass: "action",
      on: {
        "click": function($event) {
          _vm.copyToClipboard(file)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-clipboard fa-fw",
      attrs: {
        "aria-hidden": "true"
      }
    })])])
  }))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('strong', [_vm._v("Files")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Files")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b4ee705c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/back/page-edit/FileManager.vue
// module id = 270
// module chunks = 1